// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1oQjW","footer":"ModalInfo_footer__3KpMp"};